export const setLangCookie = (lang = "en") => {
  // Set user language cookie for one month
  if (typeof window !== "undefined") {
    const date = new Date();
    date.setMonth(date.getMonth() + 1);
    document.cookie = `search_lang=${lang}; path=/; expires=${date.toUTCString()}; samesite=none; secure`;
  }
};

export const getLangCookie = () => {
  let searchLangCookie;
  if (typeof window !== "undefined") {
    const value = `; ${document.cookie}`;
    const parts = value.split("; search_lang=");
    if (parts.length === 2) {
      searchLangCookie = parts.pop().split(";").shift();
    }
  }
  return searchLangCookie || "en";
};
